import { pxToNumber, Spacing } from '@billy/design-system'

export const DASHBOARD_WIDGET_SPACING = pxToNumber(Spacing.S32)
